<template>
  <pt-batch-monitoring class="pt-batch-monitoring__page"></pt-batch-monitoring>
</template>

<script>
import PtBatchMonitoring from 'cps/data-statistics/pt-batch-monitoring/withData'
export default {
  name: 'pt-batch-monitoring__view',
  components: {
    'pt-batch-monitoring': PtBatchMonitoring
  }
}
</script>
